import type { SFC } from 'react';

import COLORS from '../../../theme/colors';
import { RevisionIssueScanState } from '../../../types';
import Icon, { icons } from '../Icon';
import type { Revision } from '../../../types';

import getCommitStatus from './getCommitStatus';
import Pill from './Pill';

const STYLES_MAP = {
  [RevisionIssueScanState.IssuesFound]: {
    borderColor: COLORS.fossaRed,
    color: COLORS.fossaRed,
  },
  [RevisionIssueScanState.Passing]: {
    color: COLORS.fossaGreen,
  },
  [RevisionIssueScanState.NeedsConfiguration]: {
    color: COLORS.fossaYellow,
  },
};

const CommitPill: SFC<{
  label: string;
  revision: Revision;
}> = ({
  revision,
  label,
}) => {
  const status = getCommitStatus(revision);
  const style = STYLES_MAP[status] || null;
  return (
    <Pill style={style}>
      <Icon icon={icons.circle} />
      <span className="margin-left-xs">
        {label}
      </span>
    </Pill>
  );
};

export default CommitPill;
